import React from 'react'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import Footer from '../components/footer'
import './prora.css'

const Prora = (props) => {
  return (
    <div className="prora-container1">
      <Helmet>
        <title>Prora - marjangerrits.nl</title>
        <meta name="description" content="blog over Tweede Wereldoorlog" />
        <meta property="og:title" content="Prora - marjangerrits.nl" />
        <meta
          property="og:description"
          content="blog over Tweede Wereldoorlog"
        />
      </Helmet>
      <NavbarInteractive rootClassName="navbar-interactiveroot-class-name18"></NavbarInteractive>
      <div className="prora-blogtitel-en-datum">
        <div className="prora-container2">
          <h1 className="prora-titel BlogTitel">
            <span>
              Prora.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <span>Heeft Hitler toch zijn zin gekregen?</span>
          </h1>
        </div>
      </div>
      <div className="prora-container3">
        <p className="prora-datum">
          <span>09-07-2024</span>
          <br></br>
        </p>
        <img alt="image" src="/prora-1500h.jpg" className="prora-foto" />
        <span className="prora-tekst">
          <span>
            Ben je wel eens op het Duitse eiland Rügen geweest? Een prachtig
            eiland met mooie natuur, bijzondere krijtrotsen en heerlijke
            stranden. Hitler vond dat kennelijk ook want hij liet in het
            plaatsje Prora een enorm vakantiecomplex bouwen in de jaren voor de
            oorlog. Een enorme kolos van ruim vier kilometer, alle kamers met
            uitzicht op zee. Bedoeld voor een betaalbare vakantie voor de dertig
            miljoen Duitsers die in 1936 lid waren van de
            nationaalsocialistische organisatie Kraft durch Freude (KdF),
            onderdeel van het Deutsche Arbeitsfront. Deze organisatie was onder
            andere bedoeld om de arbeiders tevreden te houden met vakanties die
            normaal alleen betaald konden worden door de rijken.
          </span>
          <br></br>
          <span>
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br></br>
          <span>
            Maar ja, in 1939 begon de Tweede Wereldoorlog en de bouw van het
            vakantieoord werd gestaakt. Hoe de oorlog afliep weten we allemaal.
            Wat er met het complex gebeurde? In de oorlog diende het als
            militair ziekenhuis en een SS-trainingsschool en tegen het eind van
            de oorlog als opvangplaats voor Duitsers wiens huizen verwoest
            waren. In mei 1945 kwam het in handen van het Rode Leger die een
            vergeefse poging deden de massieve gebouwen op te blazen.
          </span>
          <br></br>
          <span>
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br></br>
          <span>
            Ondertussen is het door investeerders ontdekt die een groot gedeelte
            verbouwd hebben tot luxe appartementen. (Op de foto een
            gerestaureerd en een nog niet gerestaureerd deel). Een aantal
            Duitsers vindt het maar niets. Zo lijkt het of Hitler alsnog zijn
            zin krijgt. Maar de recensies op internet, ook van Duitsers, zijn
            lovend. Zouden de vakantiegangers weten dat ze in Hitlers
            vakantieparadijs beland zijn? Hopelijk ligt er op elke kamer een
            informatiemap met bovenin een folder van het nabij gelegen
            documentatiecentrum.
          </span>
          <br></br>
          <br></br>
          <span>
            Heeft Hitler zijn zin gekregen? Gelukkig niet. Het inperken van
            kritische gedachten, een van de doelen van de projecten van de KdF,
            is nu totaal niet aan de orde. Maar ook de doelgroep is niet meer
            dezelfde. Wat bedoeld was voor een betaalbare vakantie voor de
            arbeidersklasse, is veranderd in een luxe vakantie die niet iedereen
            zal kunnen betalen. En dat vind ik dan toch wel weer jammer.
          </span>
          <span></span>
        </span>
      </div>
      <div className="prora-andere-blogs">
        <h2 className="prora-lees-ook">
          <span>Lees ook:</span>
          <br></br>
        </h2>
        <div className="prora-laatste3-blogposts"></div>
      </div>
      <Footer rootClassName="footerroot-class-name19"></Footer>
    </div>
  )
}

export default Prora
